import { Link } from 'react-router-dom';
import styled from 'styled-components'; // Styled Componentsを使用している前提

// 受け取るデータの型定義
interface BreadcrumbItem {
    label: string;
    path?: string; // URLがない場合はリンクにしない（現在のページなど）
  }
  
  interface Props {
    items: BreadcrumbItem[];
  }
  
  export const Breadcrumb = ({ items }: Props) => {
    return (
      <BreadcrumbSection>
        <BreadcrumbContainer>
          <BreadcrumbText>
            {/* 最初のトップページ固定リンク */}
            <Link to="/">トップ</Link>
            
            {items.map((item, index) => (
              <span key={index}>
                {" > "}
                {item.path ? (
                  <Link to={item.path}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </span>
            ))}
          </BreadcrumbText>
        </BreadcrumbContainer>
      </BreadcrumbSection>
    );
  };

const BreadcrumbSection = styled.div.attrs({className: 'breadcrumb-section'})`
  max-width: var(--contents-maxwidth-pc);
  margin-right:auto;
  margin-left:auto;
  padding: 80px 0 40px;
  @media (min-width: 769px) {
    width:95%;
  }
`;


const BreadcrumbContainer = styled.div.attrs({className: 'breadcrumb-container'})`

`;

const BreadcrumbText = styled.p.attrs({className: 'breadcrumb-text'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  color: #9B9B9B;
  margin: 0;

  a {
    color: #9B9B9B;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #0F3F8E;
    }
  }
`;